import {action, observable} from 'mobx';
import {databaseRef} from '../../helperFunctions/firebaseStore';
import {convertObjToArray} from "./ordersStore";
import {IRequest, IUsersRequestsStore} from "../storeInterfaces/usersRequestsInterface";

export class UsersRequestsStore implements IUsersRequestsStore {

    @observable
    requests: IRequest[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    async getUsersRequests() {
        try {
            await databaseRef.ref('/usersRequests/').on('value', snapshot => {
                this.requests = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
        } catch (e) {
            this.failed = true;
        } finally {
            this.loaded = true;
        }
    }
}